import React,{useState,useEffect,useRef} from 'react'
import Functions from './function'
import { useParams } from 'react-router-dom';
import { QRCodeSVG } from "qrcode.react";
import ToothChart from '../../../components/labeltoothchart'
import CaseDetails from '../../../components/labelcasedetails'
// Deliberately imports the labadmin label's stylesheet and reuses its class rather than
// keeping a second copy here. These two labels print on the same stock and must stay
// identical; a duplicated stylesheet is what let them drift apart before (this page's own
// index.css was deleted, so it silently lost the font and the sticker sizing).
import '../../labadminprints/label/index.css'

// 4in x 3in sticker (Zebra TLP 2844-Z). See labadminprints/label/index.jsx for why this is
// injected at runtime instead of living in the stylesheet.
const LABEL_PAGE_CSS = '@page { size: 101.6mm 76.2mm; margin: 0; }';

const Index = () => {
    const [orderdata,setOrderData] = useState(null);
    const {id} = useParams();
    // useRef, not a plain let: a local would reset on every render and never guard anything,
    // so window.print() could fire more than once.
    const inprint = useRef(false);

    useEffect(()=>{
        const style = document.createElement('style');
        style.setAttribute('data-label-page','');
        style.textContent = LABEL_PAGE_CSS;
        document.head.appendChild(style);
        return ()=>{ style.remove(); };
    },[])

    useEffect(()=>{
        Functions.Get(id,(data)=>{
            setOrderData(data);
            if(!inprint.current){
                setTimeout(() => {
                    window.print();
                    window.close();
                }, 400);
            }
            inprint.current = true;
        });
    },[id])
  return (
    <div className='labadmin_lableprint'>
    {orderdata &&
        <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <p>Invoice No: <b>{id}</b></p>
                <p>Pan No: <b>{orderdata.workingpan}</b></p>
            </div>
            {/* No contact details anywhere - see labadminprints/label/index.jsx. */}
            <div style={{border:"1px solid #000",padding:"2pt",marginTop:"2pt"}}>
                <h5 style={{fontSize:"6pt",fontWeight:"700",letterSpacing:"0.5px"}}>TO</h5>
                <p>Practice: <b>{orderdata.clinicname + " / " + orderdata.doctorname}</b></p>
                <p style={{fontSize:"10pt"}}>Patient: <b style={{fontSize:"10pt"}}>{orderdata.patient}</b></p>
            </div>
            <div style={{border:"1px solid #000",borderTop:"none",padding:"2pt"}}>
                <h5 style={{fontSize:"6pt",fontWeight:"700",letterSpacing:"0.5px"}}>CASE DETAILS</h5>
                <CaseDetails lineItems={orderdata.lineItems} orderdate={orderdata.date}/>
            </div>
            {/* QR beside the chart rather than on its own row - see the labadmin twin. */}
            <div style={{border:"1px solid #000",borderTop:"none",padding:"2pt"}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                    <div style={{flex:"0 0 auto"}}>
                        <h5 style={{fontSize:"6pt",fontWeight:"700",letterSpacing:"0.5px"}}>TOOTH CHART</h5>
                        <ToothChart lineItems={orderdata.lineItems}/>
                    </div>
                    <div style={{flex:"0 0 auto"}}>
                        <QRCodeSVG
                            id="qrCode"
                            value={String(id)}
                            bgColor={"#ffffff"}
                            fgColor={"#000000"}
                            level={"H"}
                            includeMargin={true}
                            size={54}
                            shapeRendering="crispEdges"
                        />
                    </div>
                </div>
            </div>
            <p style={{fontSize:"7pt",fontWeight:"700",marginTop:"2pt"}}>N-Vision digital dental laboratory</p>
        </>
    }
    </div>
  )
}

export default Index
